import {useState} from "react";

import {Button, Layout, Menu, theme} from "antd";
import {
    BarChartOutlined,
    DiffOutlined,
    FileExcelOutlined,
    FileSearchOutlined,
    ImportOutlined,
    LogoutOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    RollbackOutlined,
} from '@ant-design/icons';
import Sider from "antd/es/layout/Sider";
import {Content, Header} from "antd/es/layout/layout";

import ImportData from "./ImportData";
import DownloadExcel from "./DownloadExcel";
import NetSalesDashboard from "./NetSalesDashboard";
import RefundsDashboard from "./RefundsDashboard";
import ListingsCheck from "./ListingsCheck";
import AllistCompare from "./AllistCompare";

const PAGE_TITLES = {
    Dashboard: "Сводный дашборд продаж",
    Refunds: "Дашборд возвратов",
    Main: "Выгрузка по SKU / ASIN",
    DataImport: "Импорт данных",
    Listings: "Проверка листингов (All Listings)",
    AllistCompare: "Сравнение All List (manager.enjoytool.net)",
};

export default function Addtask() {
    const {
        token: {borderRadiusLG},
    } = theme.useToken();

    const stored = localStorage.getItem("currentpage");
    const [currentPage, setCurrent] = useState(!stored || stored === "" ? "Dashboard" : stored);
    const [collapsed, setCollapsed] = useState(false);

    const MenuItems = [
        {key: 'Dashboard', icon: <BarChartOutlined/>, label: 'Сводный дашборд'},
        {key: 'Refunds', icon: <RollbackOutlined/>, label: 'Возвраты'},
        {key: 'Main', icon: <FileExcelOutlined/>, label: 'Выгрузка SKU/ASIN'},
        {key: 'DataImport', icon: <ImportOutlined/>, label: 'Импорт данных'},
        {key: 'Listings', icon: <FileSearchOutlined/>, label: 'Проверка листингов'},
        {key: 'AllistCompare', icon: <DiffOutlined/>, label: 'Сравнение All List'},
        {type: 'divider'},
        {key: 'Logout', icon: <LogoutOutlined/>, label: 'Выйти', danger: true},
    ];

    const onClickMenu = (e) => {
        if (e.key === "Logout") {
            localStorage.setItem("currentpage", "Dashboard");
            localStorage.setItem("token", "");
            window.location.replace("/login");
        } else {
            setCurrent(e.key);
            localStorage.setItem("currentpage", e.key);
        }
    };

    const siderWidth = collapsed ? 80 : 250;

    return (
        <Layout>
            <Sider
                width={250}
                collapsedWidth={80}
                style={{
                    overflow: 'auto',
                    height: '100vh',
                    position: 'fixed',
                    insetInlineStart: 0,
                    top: 0,
                    bottom: 0,
                    scrollbarWidth: 'thin',
                    scrollbarGutter: 'stable',
                    background: 'linear-gradient(180deg, #1b1430 0%, #120d1f 100%)',
                    borderRight: '1px solid #2a2140',
                }}
                trigger={null} collapsible collapsed={collapsed}>

                {/* Брендинг */}
                <div style={{
                    padding: collapsed ? '20px 8px' : '20px 22px',
                    textAlign: collapsed ? 'center' : 'left',
                }}>
                    <span style={{
                        fontWeight: 800,
                        fontSize: collapsed ? 18 : 20,
                        color: '#fff',
                        whiteSpace: 'nowrap',
                    }}>
                        {collapsed ? 'AR' : 'Amazon Reports'}
                    </span>
                </div>

                <Menu
                    onClick={onClickMenu}
                    mode="inline"
                    selectedKeys={[currentPage]}
                    items={MenuItems}
                    style={{background: 'transparent', borderInlineEnd: 'none', padding: '6px 8px'}}
                />
            </Sider>

            <Layout style={{marginInlineStart: siderWidth, transition: 'margin 0.2s'}}>
                <Header style={{
                    position: 'sticky', top: 0, zIndex: 10,
                    padding: '0 20px', height: 60, lineHeight: '60px',
                    display: 'flex', alignItems: 'center', gap: 12,
                    background: 'rgba(24,18,38,0.92)',
                    backdropFilter: 'blur(8px)',
                    borderBottom: '1px solid #2a2140',
                }}>
                    <Button
                        type="text"
                        icon={collapsed ? <MenuUnfoldOutlined/> : <MenuFoldOutlined/>}
                        onClick={() => setCollapsed(!collapsed)}
                        style={{fontSize: '18px', color: '#fff'}}
                    />
                    <span style={{fontSize: 17, fontWeight: 600, color: '#fff'}}>
                        {PAGE_TITLES[currentPage] || ""}
                    </span>
                </Header>

                <Content style={{
                    margin: 0,
                    minHeight: 'calc(100vh - 60px)',
                    borderRadius: borderRadiusLG,
                }}>
                    {currentPage === "Dashboard" && <NetSalesDashboard/>}
                    {currentPage === "Refunds" && <RefundsDashboard/>}
                    {currentPage === "DataImport" && <ImportData/>}
                    {currentPage === "Main" && <DownloadExcel/>}
                    {currentPage === "Listings" && <ListingsCheck/>}
                    {currentPage === "AllistCompare" && <AllistCompare/>}
                </Content>
            </Layout>
        </Layout>
    );
}
